import React from 'react';
import PropTypes from 'prop-types';
import { tickerToSymbols, getCurrencyInfo } from '@/utils/currencies';
import styled from 'styled-components';

const StyledLink = styled.a`
  text-decoration: none;
  color: inherit;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const CurrencyPair = ({ ticker, size = 20 }) => {
  const [currency1, currency2] = tickerToSymbols(ticker);

  const renderCurrency = symbol => {
    const currencyInfo = getCurrencyInfo(symbol);

    return (
      <span
        style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
      >
        {currencyInfo.name}
        <img
          style={{
            display: 'inline-block',
            width: size,
            height: size,
            objectFit: 'contain',
          }}
          src={currencyInfo.logo}
          alt={currencyInfo.name}
          onError={e => {
            // Fallback to text if image fails to load
            e.target.style.display = 'none';
          }}
        />
      </span>
    );
  };

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
      <StyledLink
        href={`/CryptoTokenIntroduction#${currency1}`}
        title={`Go to ${currency1} introduction`}
      >
        {renderCurrency(currency1)}
      </StyledLink>
      <span>/</span>
      {renderCurrency(currency2)}
      {ticker.toLowerCase().includes('audd') && (
        <img
          src="/images/new.png"
          alt="new"
          style={{
            width: 32,
            height: 32,
            marginLeft: 6,
            verticalAlign: 'middle',
          }}
        />
      )}
    </span>
  );
};

CurrencyPair.propTypes = {
  ticker: PropTypes.string.isRequired,
  size: PropTypes.number,
};

export default CurrencyPair;
